var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "colour-selector-paint-button",
      class: [
        {
          "colour-selector-paint-button--black":
            _vm.selectedColour && _vm.colour.id === _vm.selectedColour.id,
        },
        _vm.isColourPage
          ? "colour-selector-paint-button--colour-page"
          : "h-10.5 w-10.5 rounded-full",
      ],
      style: { backgroundColor: _vm.colour.hex },
      on: {
        click: function ($event) {
          return _vm.$emit("handle-click", _vm.colour)
        },
        mouseover: function ($event) {
          return _vm.$emit("change-colour", _vm.colour)
        },
      },
    },
    [_c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.colour.title))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }